import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink
} from "react-router-dom";

import { useState, useEffect } from "react";
import * as API from "../services/datconsumo";
import { FormatDate } from "../components/documentacion/FormatDate";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllDatconsumoByTax(params.tratamientoId);
}

export function DatconsumoList(props) {
  const [datconsumoList, setDatconsumo] = useState([]);
  let { tratamientoId } = useParams();
  let lastItem;

  useEffect(() => {
    API.getAllDatconsumoByTax(props.id).then(setDatconsumo).catch(console.log);
  }, [props.id]);

  return (
    <>
      {datconsumoList?.length ? (
        <ul className="entrenamiento cpt-list">
            {datconsumoList
              .sort((a, b) => {
                // Convertir las fechas a objetos de fecha para comparar
                const dateA = new Date(a.meta.metaFecha);
                const dateB = new Date(b.meta.metaFecha);
                // Ordenar de manera descendente (más reciente primero)
                return dateB - dateA;
              })
              .map((datconsumo) => (
                <li key={datconsumo.id}>
                  <NavLink className="capitalize" to={`${props.id}/antecedentes/datos-consumo/${datconsumo.id}`}>
                  {`${FormatDate(datconsumo.meta.metaFecha)} - ${datconsumo.meta.datconsTipo !== 'Valoración' ? 'Ingreso' : 'Valoración'}`}
                  </NavLink>
                </li>
              ))}
          </ul>
          ) : (
            <></>
          )}
    </>
  );
}



export function DatconsumoListContent() {
  let { tratamientoId } = useParams();
  console.log(tratamientoId);
  return (
    <>
      <div id="content">
        <h1>Datos de Consumo</h1>
      </div>
      <div id="actions">
        {<Link className="button is-link" to={`new`}>Nuevo</Link>}
      </div>
    </>
  );
}